import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router'
import { Utils } from 'app/components/utils/Utils';
import { ParameterCart } from 'app/models/cart-model';
import { StockModel } from 'app/models/stock-model';
import { AppService } from 'app/services/app/app.service';
import { LanguageService } from 'app/services/language/language.service';
import { EventsService } from 'app/services/events/events.service';
import { RestService } from 'app/services/rest/rest.service';
import { Location } from '@angular/common';
import { environment } from 'environments/environment';
import { StepModel } from 'app/models/step-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { StockDetailRequestModel } from 'app/models/stock-detail-request-model';
import { Log } from 'app/core/logging/log';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reserve-main',
    templateUrl: './reserve-main.component.html',
    styleUrls: ['./reserve-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReserveMainComponent implements OnInit, OnDestroy {
    parameters: ParameterCart;
    public environment = environment;
    test : Date = new Date();
    lockers: StockModel[] = [];
    step: StepModel;
    nLocker: any = {};
    type: any = 'BAGAGGE';
    showPreviousBt: boolean = false;
    showNextBt: boolean = false;
    enabledNextBt: boolean = false;
    showPaymentBt: boolean = false;
    showPaymentPaypalBt: boolean = true;
    showPaymentFreeBt: boolean = false;
    selectedPaymentMethod: 'card' | 'paypal' = 'card';
    checkoutTotal: number = 0;
    nameNextBt: string;
    mode: string;
    currentStock$: Subscription;
    calculatorStep2$: Subscription;
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
      //console.log('Back button pressed');
      //this.goBack();
    }
    
    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private language: LanguageService,
        private appService: AppService,
        private restService: RestService,
        private eventsService: EventsService,
        public location: Location) { }

    ngOnInit() {
        this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
        
        const paths = ['locker-date', 'locker-type', 'locker-size','checkout', 'visor'];
        this.route.paramMap.subscribe(params => {
            const kiosk = params.get('kiosk');
            if(kiosk != null){
                this.appService.kiosk = kiosk;
                if(paths.indexOf(kiosk) == -1){
                    this.getStockLockers();
                    const parameters:ParameterCart = Utils.getParams(this.route.snapshot.queryParamMap);
                    this.calculatorStep2(parameters);
                }
            }
        });

        this.eventsService.subscribe('calculatorStep2', (param:ParameterCart) =>{
            this.calculatorStep2(param);
        });


        

        this.nameNextBt = this.appService.getTraduccion('reserve.next');

        this.appService.setMeta(
            this.appService.getTraduccion('meta.reserve.title'), 
            this.appService.getTraduccion('meta.reserve.description')
        );

        this.eventsService.subscribe('refreshStep', (result:StepModel) => {
            //console.debug('ReserveMainComponent refreshStep', result);
            this.step = result;
            this.showPreviousBt = false;
            this.showNextBt = false;
            this.showPaymentBt = false;
            this.enabledNextBt = false;
            this.showPaymentFreeBt = false;
           

            if(result.nameBt){
                this.nameNextBt = result.nameBt;
            }else{
                this.nameNextBt = this.appService.getTraduccion('reserve.next');
            }
            
            if(result.title == '0/4'){      //locker-location
                this.showPreviousBt = false;
                this.showNextBt = false;
                this.enabledNextBt = false;
            }else if(result.title == '1/4'){ //locker-type
                this.showPreviousBt = false;
                this.showNextBt = false;
                this.enabledNextBt = false;
            }else if(result.title == '2/4'){ //locker-date
                this.showPreviousBt = true;
                this.showNextBt = true;
                this.enabledNextBt = result.next === true;
            }else if(result.title == '3/4'){ //locker-size
                this.showPreviousBt = true;
                this.showNextBt = true;
                this.enabledNextBt = result.next;
            }else if(result.title == '4/4'){ //locker-checkout
                this.showPaymentBt = true;
                this.showPreviousBt = true;
                this.showPaymentPaypalBt = true;
            }
        });
        
        this.eventsService.subscribe('showPaymentPaypalBt', result => {
            this.showPaymentPaypalBt = result;
            if (!result) this.selectedPaymentMethod = 'card';
        });
        this.eventsService.subscribe('showPaymentFreeBt', result => {
            this.showPaymentFreeBt = result;
        });
        this.eventsService.subscribe('checkoutPaymentSelection', (method: 'card' | 'paypal') => {
            this.selectedPaymentMethod = method;
        });
        this.eventsService.subscribe('checkoutTotal', (total: number) => {
            this.checkoutTotal = total;
        });

        this.currentStock$ = this.appService.currentStock$.subscribe((stock:StockModel)=>{
            this.mode = Utils.getMode(stock, this.parameters);
        });

    }

    ngOnDestroy() {
        this.eventsService.destroy('refreshStep');
        this.eventsService.destroy('showPaymentPaypalBt');
        this.eventsService.destroy('showPaymentFreeBt');
        this.eventsService.destroy('checkoutMethod');
        this.eventsService.destroy('calculatorStep2');
        this.eventsService.destroy('checkoutPaymentSelection');
        this.eventsService.destroy('checkoutTotal');
        this.currentStock$.unsubscribe();
        this.calculatorStep2$?.unsubscribe();
      }

      /*
    isFromsubdomainReserve() {
        return window.location.host.split('.').find(f=>f=='reserve')!=undefined;
    }*/

    
    goBack(){
        let url = this.getUrlWithoutParams();
        let parameters:ParameterCart = Utils.getParams(this.route.snapshot.queryParamMap);
         
        if(url.indexOf('checkout')!=-1){
            url = this.mode == 'KEY' ? url.replace('checkout', 'locker-date') : url.replace('checkout', 'locker-size');

        } else if(url.indexOf('locker-size')!=-1){
            url = url.replace('locker-size', 'locker-date');
        } else if(url.indexOf('locker-date')!=-1){
            url = url.replace('locker-date', 'locker-type');
        } else if(url.indexOf('locker-type')!=-1){
            url = this.language.path('locker-location');
        }else{
            throw "Url not found";
        }
        //url = this.appService.kiosk + url;
        //console.log('url', url);
        this.router.navigate([url], { queryParams: Utils.generateParams(parameters) });
    }


    clickAction(action: string){
        this.eventsService.publish('checkoutMethod', action);
    }

    payForReservation() {
        const method = this.showPaymentFreeBt || this.selectedPaymentMethod === 'card' || !this.showPaymentPaypalBt
            ? 'checkoutCardStripe' : 'checkoutCardPaypal';
        this.clickAction(method);
    }

    clickCallNext(){
        this.eventsService.publish('callNext');
    }

    getUrlWithoutParams(){
        let urlTree = this.router.parseUrl(this.router.url);
        urlTree.queryParams = {}; 
        urlTree.fragment = null;
        return urlTree.toString();
     }
      
     getStockLockers(){
        this.restService.getStockLockers().subscribe((stock:StockModel) => { 
            if(stock != undefined){
                this.appService.setCurrentStock(stock);
            }
        });
    }

    calculatorStep2(parameters:ParameterCart){
        let stockDetailRequestModel:StockDetailRequestModel = {
           startDate: parameters.startDate,
           endDate: parameters.endDate,
           categoryId: parameters.type,
           paymentFrequency: parameters?.paymentFrequency
        }
    
        if(stockDetailRequestModel.categoryId && stockDetailRequestModel.startDate && stockDetailRequestModel.endDate){
            this.calculatorStep2$?.unsubscribe();
            this.appService.setCurrentPrice(this.emptyStockPromotion());
            this.calculatorStep2$ = this.restService.calculatorStep2(stockDetailRequestModel).subscribe({
                next:(result:StockPromotionModel) => { 
                    for(let key in result.items){
                        result.items[key].promotions.forEach(p=>p.active=false);
                    }
                    this.appService.setCurrentPrice(result);
                },
                error:(err) =>{
                    Log.error('Error StockModel, StockPromotionModel', err);
                    if (!this.isNoAvailabilityError(err)) {
                        this.router.navigate([this.language.path('reserve'), this.appService.kiosk, 'locker-type'], { queryParams: Utils.generateParams(this.parameters) });
                    }
                }
            });
        }
    }

    private emptyStockPromotion(): StockPromotionModel {
        return { items: {}, minPrice: 0, total: 0 };
    }

    private isNoAvailabilityError(error: any): boolean {
        const errors = error?.error?.errors;
        return Array.isArray(errors) && errors.includes('cart.item.isEmpty');
    }
    
}
